import React, { useState, useEffect } from "react";
import { Alert, Modal, Tag, notification, Space, Button, Skeleton } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import { TrashFill } from "react-bootstrap-icons";
import Common from "../../components/includes/Common";
import { QrReader } from "react-qr-reader";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var ScanTicketFromAdmin = function ScanTicketFromAdmin() {
  var handleScanTicket = function handleScanTicket() {
    setIsTicketScanProcessing(true);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("b", {
        children: ["La destruction du ticket N\xBA ", ticket.id, " pour ", ticket.price_schema_item.price.toLocaleString("Fr"), " GNF ?"]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "scanticket", {
          ticket_id: ticket.id.toString(),
          user_id: Common.currentUser.id
        }).then(function (response) {
          if (response.data.status == 200) {
            setSuccess("validé avec succès");
            setTicket(null);
          } else {
            setScanError(response.data.message);
          }
        })["catch"](function (error) {
          setScanError("Une erreur est survenue - Code " + error.toString());
        })["finally"](function () {
          setIsTicketScanProcessing(false);
        });
      },
      onCancel: function onCancel() {
        setIsTicketScanProcessing(false);
      }
    });
  };
  var getScannedTicket = function getScannedTicket(r) {
    if (r.length == 0) return;
    setSuccess('');
    setScanError('');
    setIsTicketLoading(true);
    var req = Common.baseApiUrl + 'getticket/' + r.toString() + "/" + Common.currentUser.id.toString();
    axios.get(req).then(function (response) {
      if (response.data.status == 200) {
        setTicket(response.data.ticket);
      } else {
        setScanError(response.data.message);
      }
    })["catch"](function (error) {
      setScanError("Une erreur est survenue");
    })["finally"](function () {
      setIsTicketLoading(false);
    });
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsxs(Col, {
          lg: 5,
          md: 5,
          children: [/*#__PURE__*/_jsx(QrReader, {
            constraints: {
              facingMode: "user"
            } // Use rear camera
            ,
            onResult: function onResult(result, error) {
              if (result) {
                setScanResult(parseInt(result === null || result === void 0 ? void 0 : result.text));
                getScannedTicket(parseInt(result === null || result === void 0 ? void 0 : result.text));
              }
            },
            style: {
              width: "100%",
              borderRadius: "7px"
            }
          }), scanError.length > 0 && /*#__PURE__*/_jsx(Alert, {
            type: "error",
            message: scanError,
            showIcon: true,
            closable: true
          }), scanError.length > 0 && /*#__PURE__*/_jsx(Alert, {
            type: "success",
            message: success,
            showIcon: true,
            closable: true
          }), isTicketLoading && /*#__PURE__*/_jsx(Skeleton, {
            active: true
          }), ticket != null && /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsxs("h6", {
              style: {
                width: "100%",
                padding: "8px 13px",
                textAlign: "center",
                borderRadius: "7px",
                background: "#FFFFFF",
                color: "#6B483B"
              },
              children: ["Ticket : ", ticket.price_schema_item.label, " ", /*#__PURE__*/_jsx(Tag, {
                color: "#CC4040",
                children: ticket.price_schema_item.price.toLocaleString("Fr")
              })]
            }), contextHolder, /*#__PURE__*/_jsx(Button, {
              size: "large",
              style: {
                width: "100%"
              },
              block: true,
              disabled: ticket.status != 0,
              type: "primary",
              onClick: handleScanTicket,
              loading: isTicketScanProcessing,
              children: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(TrashFill, {
                  size: 24
                }), " VALIDER"]
              })
            })]
          })]
        }), /*#__PURE__*/_jsx(Col, {})]
      })
    })
  });
};
export default ScanTicketFromAdmin;